// Safari compatibility: _autofillcallbackhandler guard
// Releasit COD Form may invoke this Safari autofill hook. If it doesn't exist,
// Safari throws "ReferenceError: Can't find variable: _autofillcallbackhandler"
// which can silently block form autofill on iPhone.
if (typeof window._autofillcallbackhandler === 'undefined') {
  window._autofillcallbackhandler = function() {};
}

const SELECTORS = {
    BUTTON: '._rsi-build-block-submit-button ._rsi-modal-submit-button._rsi-buy-now-button',
    FORM: '#_rsi-cod-form-modal-form',
    FORM_ITEM: '._rsi-modal-fields-item',
    INPUTS: 'input, select',
  };
  const STYLES = `
      ._rsi-modal-fields-item {
        position: relative;
        padding-left: 18px !important;
        margin-bottom: 20px !important;
      }
    
      ._rsi-modal-fields-item::before {
        content: '';
        position: absolute;
        left: 2px;
        top: 0;
        width: 2px;
        height: calc(100% + 20px);
        background-color: #e0e0e0;
        z-index: 1;
        transition: background-color 0.3s ease;
      }
    
      ._rsi-modal-fields-item::after {
        content: '';
        position: absolute;
        left: -2px;
        top: 30px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #e0e0e0;
        z-index: 2;
        transition: all 0.3s ease;
      }
    
      ._rsi-modal-fields-item.has-content::before,
      ._rsi-modal-fields-item.completed::before {
        background-color: #3292e1;
      }
    
      ._rsi-modal-fields-item.has-content::after,
      ._rsi-modal-fields-item.completed::after {
        background-color: #3292e1;
        border: 2px solid #fff;
        box-shadow: 0 0 0 2px #3292e1;
        transform: scale(1.2);
      }
      `;

  const BUTTON_STYLES = {
    width: '549px',
    'max-width': '100%',
    height: '70px',
    'border-radius': '50px',
    background: '#55B004',
    'font-size': '16px',
    color: '#FFF',
    'font-weight': '700',
    'font-family': 'Montserrat',
  };

  const _rsiDebounce = (fn, delay = 100) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => fn(...args), delay);
    };
  };

  if (typeof window._rsiInlineSetupLoaded === 'undefined') {
  class FormProgressManager {
    constructor() {
      this.styleSheet = null;
      this.formObserver = null;
      this.buttonObserver = null;
      this.initialized = false;
    }

    init() {
      if (this.initialized) return;
      this.injectStyles();
      this.setupFormObserver();
      this.setupButtonObserver();
      this.initialized = true;
    }

    injectStyles() {
      if (this.styleSheet) return;
      this.styleSheet = document.createElement('style');
      this.styleSheet.textContent = STYLES;
      document.head.appendChild(this.styleSheet);
    }

    hasContent(input) {
      if (!input) return false;
      const value = input.value.trim();
      return input.tagName.toLowerCase() === 'select'
        ? value !== '' && !['Provincia', 'Ciudad'].includes(value)
        : value.length > 0;
    }

isQuantityOfferVariantField(input) {
  if (!input) return false;
  return !!(
    input.getAttribute('data-rsi-skip-progress') === '1' ||
    input.classList.contains('rsi-variant-select') ||
    input.hasAttribute('data-offer-num') ||
    input.getAttribute('data-rsi-split') === '1' ||
    input.closest('._rsi-quantity-offers-variant-selector') ||
    input.closest('.rsi-unit-row') ||
    input.closest('._rsi-quantity-offers')
  );
}

updateVisualState = _rsiDebounce((input) => {
  if (!input) return;
  if (this.isQuantityOfferVariantField(input)) {
    const offerItem = input.closest('._rsi-quantity-offers-variant-selector');
    if (offerItem) {
      offerItem.classList.remove('has-content', 'completed', 'is-next-active', 'is-next-two');
    }
    return;
  }
  const formItem = input.closest(SELECTORS.FORM_ITEM);
  if (!formItem) return;

  const hasContentValue = this.hasContent(input);
  formItem.classList.toggle('has-content', hasContentValue);
  
  if (input.id === '_rsi-field-phone') {
    const value = input.value.replace(/\D/g, '');
    const maxLength = parseInt(input.getAttribute('data-maxl')) || 8;
    
    // Si tiene contenido Y no cumple con 8 dígitos = error
    const isInvalid = hasContentValue && value.length !== maxLength;
    
    if (isInvalid) {
      formItem.classList.add('_rsi-modal-fields-item-error');
    } else {
      formItem.classList.remove('_rsi-modal-fields-item-error');
    }
    
    // Completado solo si tiene exactamente 8 dígitos
    if (value.length === maxLength) {
      formItem.classList.add('completed');
    } else {
      formItem.classList.remove('completed');
    }
  } else {
    formItem.classList.toggle('completed', hasContentValue);
  }
});

setupInputListeners(input) {
  if (!input || input.dataset.progressInitialized) return;

  if (this.isQuantityOfferVariantField(input)) {
    input.dataset.progressInitialized = 'true';
    const offerItem = input.closest('._rsi-quantity-offers-variant-selector');
    if (offerItem) {
      offerItem.classList.remove('has-content', 'completed', 'is-next-active', 'is-next-two');
    }
    return;
  }

  // Si es el campo de teléfono y no tiene el párrafo de error, lo creamos
  if (input.id === '_rsi-field-phone') {
    const formItem = input.closest(SELECTORS.FORM_ITEM);
    if (formItem && !formItem.querySelector('._rsi-modal-fields-item-error-text')) {
      const errorParagraph = document.createElement('p');
      errorParagraph.className = '_rsi-modal-fields-item-error-text';
      errorParagraph.textContent = 'Introduce un número de teléfono válido.';
      input.parentNode.insertBefore(errorParagraph, input.nextSibling);
    }
  }

  // Para otros inputs (no teléfono) usar el debounce normal
  if (input.id !== '_rsi-field-phone') {
    ['input', 'change', 'blur', 'focus'].forEach((eventType) => {
      input.addEventListener(eventType, () => this.updateVisualState(input));
    });
    input.dataset.progressInitialized = 'true';
    this.updateVisualState(input);
  } else {
    input.dataset.progressInitialized = 'true';
  }
}

    setupFormObserver() {
      const form = document.querySelector(SELECTORS.FORM);
      if (!form) {
        const formObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.initializeForm(entry.target);
              formObserver.disconnect();
            }
          });
        });

        const bodyObserver = new MutationObserver((mutations) => {
          const form = document.querySelector(SELECTORS.FORM);
          if (form) {
            formObserver.observe(form);
            bodyObserver.disconnect();
          }
        });

        bodyObserver.observe(document.body, { childList: true, subtree: true });
        return;
      }

      this.initializeForm(form);
    }

initializeForm(form) {
  form.querySelectorAll(SELECTORS.INPUTS).forEach((input) => this.setupInputListeners(input));

  // OBSERVADOR ESPECÍFICO Y CONSTANTE PARA EL TELÉFONO
  const phoneInput = form.querySelector('#_rsi-field-phone');
  if (phoneInput) {
    // VERIFICAR SI YA TIENE EL VALIDADOR PARA EVITAR DUPLICADOS
    if (phoneInput.dataset.phoneValidatorAttached) {
      return; // Ya tiene el validador, no hacer nada
    }

    // Listener directo sin debounce para validación inmediata
    const validatePhone = () => {
      const formItem = phoneInput.closest(SELECTORS.FORM_ITEM);
      if (!formItem) return;

      const value = phoneInput.value.replace(/\D/g, '');
      const maxLength = parseInt(phoneInput.getAttribute('data-maxl')) || 8;
      const hasContent = value.length > 0;

      // LÓGICA MEJORADA: Primero limpiamos TODOS los estados
      formItem.classList.remove('_rsi-modal-fields-item-error');
      formItem.classList.remove('completed');
      formItem.classList.remove('has-content');

      // Si no tiene contenido, limpiar todo
      if (!hasContent) {
        return; // Salir aquí sin agregar ninguna clase
      }

      // Si tiene contenido, agregar has-content
      formItem.classList.add('has-content');

      // Validar si tiene error (contenido pero no exactamente 8 dígitos)
      const hasError = value.length !== maxLength;

      if (hasError) {
        // Mostrar error
        formItem.classList.add('_rsi-modal-fields-item-error');
      } else {
        // Sin error = completado
        formItem.classList.add('completed');
      }
    };

    // Eventos directos sin debounce
    ['input', 'change', 'blur', 'focus', 'keyup', 'keydown'].forEach((event) => {
      phoneInput.addEventListener(event, validatePhone, true);
    });

    // Observador de mutaciones para cambios que no sean eventos
    const phoneObserver = new MutationObserver(validatePhone);
    phoneObserver.observe(phoneInput, {
      attributes: true,
      attributeFilter: ['value'],
      characterData: true,
      subtree: true
    });

    // MARCAR QUE YA TIENE EL VALIDADOR
    phoneInput.dataset.phoneValidatorAttached = 'true';

    // Validación inicial
    validatePhone();
  }

  this.formObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.matches(SELECTORS.INPUTS)) {
              this.setupInputListeners(node);
            } else {
              node.querySelectorAll(SELECTORS.INPUTS).forEach((input) => this.setupInputListeners(input));
            }
          }
        });
      }
    });
  });

  this.formObserver.observe(form, {
    attributes: true,
    childList: true,
    subtree: true,
  });
}

    setupButtonObserver() {
      const setupButton = (button) => {
        if (!button || button.dataset.buttonInitialized) return;

        button.removeAttribute('style');
        Object.entries(BUTTON_STYLES).forEach(([prop, value]) => {
          button.style.setProperty(prop, value, 'important');
        });

        button.classList.add('btn__animated');
        button.classList.add('btn__releasit-cta');
  
        button.id = 'btn_releasit_cta';
  
        button.dataset.buttonInitialized = 'true';
      };

      const buttonObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setupButton(entry.target);
          }
        });
      });

      const bodyObserver = new MutationObserver(() => {
        const button = document.querySelector(SELECTORS.BUTTON);
        if (button) {
          buttonObserver.observe(button);
          bodyObserver.disconnect(); // INP FIX: desconectar cuando el botón es encontrado
        }
      });

      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  const formProgress = new FormProgressManager();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => formProgress.init());
  } else {
    formProgress.init();
  }

  window.addEventListener('load', () => formProgress.init());
  }

  // Releasit Variant Selects

  const CONSTANTS = {
    SELECTORS: {
      FORM: '#rsi-cod-form-quantity-offers-hook',
      OFFERS: '._rsi-quantity-offers',
      OFFER_CONTAINER: '._rsi-quantity-offers-offer-container',
      VARIANT_SELECT: 'select[data-offer-num]',
      ITEM_INPUT: '._rsi-quantity-offers-item-input',
      VARIANT_SELECTOR: '._rsi-quantity-offers-variant-selector',
    },
    STORAGE_KEY: 'selectedVariant',
    DEBOUNCE_TIME: 100,
    QUANTITY_PATTERNS: [
      /^\(X1\)$/i,
      /^\(X2\)$/i,
      /^\(X3\)$/i,
      /^\(X\d+\)$/i,
      /^\(PAGUE \d+ LLEVE \d+\)$/,
      /^X1$/i,
      /^\(1\)$/i,
      /^1$/i,
    ],
  };

  const utils = {
    isElementVisible(element) {
      return element && element.offsetParent !== null && window.getComputedStyle(element).display !== 'none';
    },

    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },

    safeJsonParse(str, fallback = null) {
      try {
        return str ? JSON.parse(str) : fallback;
      } catch (err) {
        console.error(err);
        return fallback;
      }
    },
  };

  // In-memory fallback for environments where localStorage is blocked
  // (Facebook/Instagram WebView in private/ITP mode throws SecurityError on access)
  var _storageMemFallback = {};

  class StorageManager {
    static _isAvailable() {
      try {
        var testKey = '__rsi_storage_test__';
        localStorage.setItem(testKey, '1');
        localStorage.removeItem(testKey);
        return true;
      } catch (e) {
        return false;
      }
    }

    static get(key, defaultValue = null) {
      try {
        if (StorageManager._isAvailable()) {
          return utils.safeJsonParse(localStorage.getItem(key), defaultValue);
        }
        var memVal = _storageMemFallback[key];
        return memVal !== undefined ? utils.safeJsonParse(memVal, defaultValue) : defaultValue;
      } catch (err) {
        var memVal = _storageMemFallback[key];
        return memVal !== undefined ? utils.safeJsonParse(memVal, defaultValue) : defaultValue;
      }
    }

    static set(key, value) {
      try {
        if (StorageManager._isAvailable()) {
          localStorage.setItem(key, JSON.stringify(value));
        } else {
          _storageMemFallback[key] = JSON.stringify(value);
        }
        return true;
      } catch (err) {
        _storageMemFallback[key] = JSON.stringify(value);
        return true;
      }
    }
  }

  class DOMManager {
    static createNode(tag, className = '', attributes = {}) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      Object.entries(attributes).forEach(([key, value]) => {
        element.setAttribute(key, value);
      });
      return element;
    }

    static appendStyles() {
      if (document.getElementById('variant-selector-styles')) return;

      const style = this.createNode('style', '', { id: 'variant-selector-styles' });
      style.textContent = `
          .variants-container {
            display: flex;
            gap: 5px;
            margin: 10px 0;
            width: 100%;
          }
          .variant-group {
            display: flex;
            flex-direction: column;
            gap: 5px;
            width: 100%;
            
          }
          .variant-label {
             margin-bottom: 4px;
            line-height: 1 !important;
            font-size: 15px !important;
            color: #1E1F8C !important;
            font-family: var(--text-montserrat-bold) !important;
            text-transform: uppercase;
          }
        .variant-select {
          appearance: none;
          -webkit-appearance: none;
          height: 49px;
          border-radius: 24px !important;
          border: 1.13974442219288px solid #d1dceb !important;
          padding: 10px 10px !important;
          padding-left: 20px !important;
          width: 100% !important;
          font-size: 16px !important;
          color: #687e94 !important;
          font-weight: 300 !important;
          font-family: var(--text-montserrat-semibold) !important;
          padding-right: 45px !important;
          background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9IiMxZTFmOGMiIHZpZXdCb3g9IjI0MCAtNzM2IDQ4MCA1MzYiPjxwYXRoIGQ9Ik00ODAtMjAwIDI0MC00NDBsNTYtNTYgMTg0IDE4MyAxODQtMTgzIDU2IDU2LTI0MCAyNDBabTAtMjQwTDI0MC02ODBsNTYtNTYgMTg0IDE4MyAxODQtMTgzIDU2IDU2LTI0MCAyNDBaIi8+PC9zdmc+")!important;
          background-size: 25px 25px !important;
          background-repeat: no-repeat !important;
          background-position: right 15px center !important;
        }
        .variant-select:focus {
          border-color: #4a90e2;
          outline: none;
        }
          .faja__row-form {
            margin-bottom: 15px;
            border-bottom: 1px solid #e0e0e0;
            padding-bottom: 15px;
          }
          .faja__row-form:last-child {
            border-bottom: none;
            margin-bottom: 0;
            padding-bottom: 0;
          }
          .faja__title-form {
            font-weight: bold;
            color: #1E1F8C !important;
            margin-bottom: 10px;
            font-size: 14px;
            text-transform: uppercase;
          }
          `;

      document.head.appendChild(style);
    }
  }

  class VariantValidator {
    static validateInitial() {
      const container = document.querySelector(CONSTANTS.SELECTORS.FORM);
      if (!container) return false;

      const offersContainer = container.querySelector(CONSTANTS.SELECTORS.OFFERS);
      if (!offersContainer) return false;

      const variantSelects = container.querySelectorAll(CONSTANTS.SELECTORS.VARIANT_SELECT);
      if (!variantSelects.length) return false;

      const firstSelect = variantSelects[0];
      const options = Array.from(firstSelect.options).map((opt) => opt.textContent.trim());

      return !this.isValidSelect(options);
    }

    static isValidSelect(options) {
      if (options.length > 3) return false;

      return options.every((option) => {
        const parts = option.split('/').map((part) => part.trim());
        const firstPart = parts[0];

        if (parts.length > 1) return false;
        return CONSTANTS.QUANTITY_PATTERNS.some((pattern) => pattern.test(firstPart));
      });
    }

    static isQuantityVariant(firstVariantOptions) {
      return firstVariantOptions.every((option) => {
        return CONSTANTS.QUANTITY_PATTERNS.some((pattern) => pattern.test(option));
      });
    }
  }

  class VariantProcessor {
    constructor() {
      this.processedSelects = new WeakSet();
      this.isProcessing = false;
      this.inputCounter = 0; // Contador global para generar índices únicos
    }

    processOptions(options) {
      const sets = options.reduce(
        (acc, option) => {
          const [first, second, third] = option.split(' / ').map((part) => part.trim());
          acc.first.add(first);
          acc.second.add(second);
          acc.third.add(third);
          return acc;
        },
        {
          first: new Set(),
          second: new Set(),
          third: new Set(),
        }
      );

      return [Array.from(sets.first), Array.from(sets.second), Array.from(sets.third)];
    }

    // Función corregida para crear múltiples filas de fajas con inputs correctos
    createMultipleFajaRows(
      fajaOptions,
      secondOptions,
      thirdOptions,
      originalSelect,
      selectedVariant,
      isSelected,
      variantSelectorContainer,
      offerIndex,
      selectorIndex
    ) {
      const mainContainer = DOMManager.createNode('div', 'multiple-fajas-container');

      // Limpiar todos los inputs existentes de este contenedor de variant selector específico
      this.clearExistingInputsForContainer(variantSelectorContainer, offerIndex, selectorIndex);

      fajaOptions.forEach((faja, fajaIndex) => {
        // Crear contenedor para cada fila de faja
        const fajaRowContainer = DOMManager.createNode('div', 'faja__row-form');
        fajaRowContainer.setAttribute('data-faja-index', fajaIndex);

        // Título de la faja
        const fajaTitle = DOMManager.createNode('div', 'faja__title-form');
        fajaTitle.textContent = `${fajaIndex + 1}. ${faja}`;
        fajaRowContainer.appendChild(fajaTitle);

        // Crear contenedor de variantes para esta faja
        const variantsContainer = DOMManager.createNode('div', 'variants-container');

        // Crear selectores de color y talla para esta faja específica
        const colorGroup = this.createVariantGroup(secondOptions, 'Color', 'color');
        const tallaGroup = this.createVariantGroup(thirdOptions, 'Talla', 'talla');

        // Aplicar valores seleccionados previamente si existen
        if (selectedVariant) {
          if (selectedVariant.color && secondOptions.includes(selectedVariant.color)) {
            colorGroup.select.value = selectedVariant.color;
          }
          if (selectedVariant.size && thirdOptions.includes(selectedVariant.size)) {
            tallaGroup.select.value = selectedVariant.size;
          }
        }

        variantsContainer.append(colorGroup.group, tallaGroup.group);
        fajaRowContainer.appendChild(variantsContainer);

        // Generar un índice único y secuencial para cada faja
        const uniqueInputIndex = this.inputCounter++;

        // Crear función de actualización para esta fila específica
        const updateOriginalSelect = utils.debounce(() => {
          const combinedValue = `${faja} / ${colorGroup.select.value} / ${tallaGroup.select.value}`;
          const option = Array.from(originalSelect.options).find((opt) => opt.textContent.trim() === combinedValue);

          if (option) {
            this.createHiddenInputsForFaja(
              variantSelectorContainer,
              uniqueInputIndex,
              option.value,
              fajaIndex,
              offerIndex,
              selectorIndex
            );
          }
        }, CONSTANTS.DEBOUNCE_TIME);

        // Agregar event listeners a los selectores de esta fila
        [colorGroup.select, tallaGroup.select].forEach((select) => {
          select.addEventListener('change', updateOriginalSelect);
        });

        mainContainer.appendChild(fajaRowContainer);

        // Ejecutar la actualización inicial
        setTimeout(updateOriginalSelect, 100);
      });

      return mainContainer;
    }

    // Nueva función para limpiar inputs existentes de un contenedor específico
    clearExistingInputsForContainer(variantSelectorContainer, offerIndex, selectorIndex) {
      const offerContainer = variantSelectorContainer.closest('._rsi-quantity-offers-offer-container');
      if (!offerContainer) return;

      // Buscar todos los inputs que pertenecen a este selector específico
      const existingInputs = offerContainer.querySelectorAll(
        `input._rsi-quantity-offers-item-input[data-offer-index="${offerIndex}"][data-selector-index="${selectorIndex}"]`
      );

      existingInputs.forEach((input) => input.remove());
    }

    createVariantGroup(options, label, dataType) {
      const group = DOMManager.createNode('div', 'variant-group');
      const labelEl = DOMManager.createNode('div', 'variant-label');
      labelEl.textContent = label;

      const select = DOMManager.createNode('select', 'variant-select', {
        'data-type': dataType,
      });

      options.forEach((option) => {
        const opt = DOMManager.createNode('option');
        opt.value = option;
        opt.textContent = option;
        select.appendChild(opt);
      });

      group.append(labelEl, select);
      return { group, select };
    }

    createVariantSelectors(
      firstOptions,
      secondOptions,
      thirdOptions,
      originalSelect,
      selectedVariant,
      isSelected,
      variantSelectorContainer,
      offerIndex,
      selectorIndex
    ) {
      // Detectar si la primera variante es cantidad o fajas
      const isFirstQuantity = VariantValidator.isQuantityVariant(firstOptions);

      // Si NO es cantidad (es decir, es "Fajas"), crear múltiples filas
      if (!isFirstQuantity && firstOptions.length > 1) {
        return this.createMultipleFajaRows(
          firstOptions,
          secondOptions,
          thirdOptions,
          originalSelect,
          selectedVariant,
          isSelected,
          variantSelectorContainer,
          offerIndex,
          selectorIndex
        );
      }

      // Lógica original para casos de cantidad o una sola opción
      const container = DOMManager.createNode('div', 'variants-container');

      let firstLabel, secondLabel, thirdLabel;

      if (isFirstQuantity) {
        firstLabel = 'Cantidad';
        secondLabel = 'Color';
        thirdLabel = 'Talla';
      } else {
        firstLabel = 'Fajas';
        secondLabel = 'Color';
        thirdLabel = 'Talla';
      }

      const selectors = {
        first: this.createVariantGroup(firstOptions, firstLabel, firstLabel.toLowerCase()),
        second: this.createVariantGroup(secondOptions, secondLabel, secondLabel.toLowerCase()),
        third: this.createVariantGroup(thirdOptions, thirdLabel, thirdLabel.toLowerCase()),
      };

      // Aplicar valores seleccionados previamente
      if (selectedVariant) {
        if (selectedVariant.color && secondOptions.includes(selectedVariant.color)) {
          selectors.second.select.value = selectedVariant.color;
        }
        if (selectedVariant.size && thirdOptions.includes(selectedVariant.size)) {
          selectors.third.select.value = selectedVariant.size;
        }
      }

      // Solo ocultar si realmente es una variante de cantidad
      if (isFirstQuantity) {
        selectors.first.group.style.display = 'none';
      }

      const updateOriginalSelect = utils.debounce(() => {
        const combinedValue = `${selectors.first.select.value} / ${selectors.second.select.value} / ${selectors.third.select.value}`;
        const option = Array.from(originalSelect.options).find((opt) => opt.textContent.trim() === combinedValue);

        if (option) {
          option.selected = true;
          originalSelect.dispatchEvent(new Event('change', { bubbles: true }));

          if (isSelected) {
            const globalIndex = this.inputCounter++;
            this.createHiddenInputs(originalSelect, globalIndex, option.value, offerIndex, selectorIndex);
          }
        }
      }, CONSTANTS.DEBOUNCE_TIME);

      Object.values(selectors).forEach(({ select }) => {
        select.addEventListener('change', updateOriginalSelect);
      });

      container.append(selectors.first.group, selectors.second.group, selectors.third.group);

      setTimeout(updateOriginalSelect, 50);

      return container;
    }

    createHiddenInputs(originalSelect, inputIndex, variantId, offerIndex, selectorIndex) {
      const inputs = [
        {
          name: `item_variant_id[qty_offer_${inputIndex}]`,
          value: variantId,
        },
        {
          name: `item_quantity[qty_offer_${inputIndex}]`,
          value: '1',
        },
      ].map(({ name, value }) => {
        const input = DOMManager.createNode('input', CONSTANTS.SELECTORS.ITEM_INPUT.slice(1), {
          type: 'hidden',
          name,
          value,
          'data-progress-initialized': 'true',
          'data-offer-index': offerIndex,
          'data-selector-index': selectorIndex,
        });
        return input;
      });

      inputs.forEach((input) => {
        const existing = originalSelect.parentNode.querySelector(`input[name="${input.name}"]`);
        if (existing) {
          existing.replaceWith(input);
        } else {
          originalSelect.parentNode.appendChild(input);
        }
      });
    }

    createHiddenInputsForFaja(variantSelectorContainer, uniqueIndex, variantId, fajaIndex, offerIndex, selectorIndex) {
      const offerContainer = variantSelectorContainer.closest('._rsi-quantity-offers-offer-container');

      if (!offerContainer) {
        console.error('No se encontró el contenedor de oferta');
        return;
      }

      // Verificar si la oferta está seleccionada
      const isSelected = offerContainer.classList.contains('_rsi-quantity-offers-selected');
      if (!isSelected) {
        return;
      }

      // Limpiar inputs existentes con el mismo uniqueIndex antes de crear nuevos
      const existingInputs = offerContainer.querySelectorAll(`input[name*="qty_offer_${uniqueIndex}"]`);
      existingInputs.forEach((input) => input.remove());

      const inputs = [
        {
          name: `item_variant_id[qty_offer_${uniqueIndex}]`,
          value: variantId,
        },
        {
          name: `item_quantity[qty_offer_${uniqueIndex}]`,
          value: '1',
        },
      ].map(({ name, value }) => {
        const input = DOMManager.createNode('input', CONSTANTS.SELECTORS.ITEM_INPUT.slice(1), {
          type: 'hidden',
          name,
          value,
          'data-progress-initialized': 'true',
          'data-faja-index': fajaIndex,
          'data-offer-index': offerIndex,
          'data-selector-index': selectorIndex,
          'data-unique-index': uniqueIndex,
        });
        return input;
      });

      // Agregar todos los inputs al contenedor de la oferta
      inputs.forEach((input) => {
        offerContainer.appendChild(input);
      });
    }

    async process() {
      // New splitter: assets/releasit-variant-split.js
      if (window.__rsiDisableLegacyVariantProcessor || window.__rsiVariantSplitV2) {
        if (typeof window._rsiProcessQuantityOfferVariants === 'function') {
          window._rsiProcessQuantityOfferVariants(false);
        }
        return;
      }

      if (!VariantValidator.validateInitial() || this.isProcessing) return;

      this.isProcessing = true;

      try {
        DOMManager.appendStyles();

        const offersContainer = document.querySelector(CONSTANTS.SELECTORS.OFFERS);
        if (!offersContainer || !utils.isElementVisible(offersContainer)) {
          return;
        }

        const selectedVariant = StorageManager.get(CONSTANTS.STORAGE_KEY);
        const offerElements = offersContainer.querySelectorAll(CONSTANTS.SELECTORS.OFFER_CONTAINER);

        // Resetear contador para cada procesamiento
        this.inputCounter = 0;

        offerElements.forEach((offer, offerIndex) => {
          const variantSelectors = offer.querySelectorAll(CONSTANTS.SELECTORS.VARIANT_SELECTOR);
          const isSelected = offer.classList.contains('_rsi-quantity-offers-selected');

          // Limpiar inputs existentes solo si no está seleccionada
          if (!isSelected) {
            const existingInputs = offer.querySelectorAll(CONSTANTS.SELECTORS.ITEM_INPUT);
            existingInputs.forEach((input) => input.remove());
          }

          variantSelectors.forEach((variantSelector, selectorIndex) => {
            const originalSelect = variantSelector.querySelector(CONSTANTS.SELECTORS.VARIANT_SELECT);

            if (!originalSelect || this.processedSelects.has(originalSelect)) return;

            const existingContainer = originalSelect.previousElementSibling;
            if (
              (existingContainer && existingContainer.classList.contains('variants-container')) ||
              (existingContainer && existingContainer.classList.contains('multiple-fajas-container'))
            )
              return;

            const options = Array.from(originalSelect.options).map((opt) => opt.textContent.trim());
            const [firstOptions, secondOptions, thirdOptions] = this.processOptions(options);

            const container = this.createVariantSelectors(
              firstOptions,
              secondOptions,
              thirdOptions,
              originalSelect,
              selectedVariant,
              isSelected,
              variantSelector,
              offerIndex,
              selectorIndex
            );

            originalSelect.style.display = 'none';
            originalSelect.parentNode.insertBefore(container, originalSelect);

            this.processedSelects.add(originalSelect);
          });
        });
      } catch (error) {
        console.error('Error en el procesamiento de variantes:', error);
      } finally {
        this.isProcessing = false;
      }
    }
  }

  class VariantHandler {
    constructor() {
      this.processor = new VariantProcessor();
      this.init();
    }

    init() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup());
      } else {
        this.setup();
      }
    }

    setup() {
      this.setupObservers();
      this.attachEventListeners();
      this.initialProcess();
    }

    setupObservers() {
      const containerObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'class' &&
            mutation.target.classList.contains('_rsi-quantity-offers-offer-container')
          ) {
            // Pequeño delay para asegurar que el DOM se haya actualizado
            setTimeout(() => {
              this.processor.process();
            }, 50);
          }
        });
      });

      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (
              node.id === '_rsi-cod-form-modal' ||
              (node.querySelector && node.querySelector('._rsi-quantity-offers'))
            ) {
              observer.disconnect(); // INP FIX: ya encontró el modal, dejar de observar body

              setTimeout(() => {
                this.processor.process();
              }, 100);

              const containers = document.querySelectorAll('._rsi-quantity-offers-offer-container');
              containers.forEach((container) => {
                containerObserver.observe(container, {
                  attributes: true,
                  attributeFilter: ['class'],
                });
              });

              return;
            }
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }

    attachEventListeners() {
      document.addEventListener(
        'change',
        utils.debounce((e) => {
          if (this.isVariantElement(e.target)) {
            this.handleVariantChange();
          }
        }, CONSTANTS.DEBOUNCE_TIME)
      );

      document.addEventListener(
        'click',
        utils.debounce((e) => {
          const radio = e.target.closest('input[type="radio"][name*="Color"]');
          if (radio) {
            this.handleVariantChange();
          }
        }, CONSTANTS.DEBOUNCE_TIME)
      );
    }

    isVariantElement(element) {
      return (
        element.closest('variant-selects') ||
        element.matches('input[type="radio"][name*="Color"]') ||
        element.matches('select[name*="Talla"]')
      );
    }

    handleVariantChange() {
      const variantData = {
        color: this.getSelectedValue('color'),
        size: this.getSelectedValue('size'),
        quantity: 1,
      };

      StorageManager.set(CONSTANTS.STORAGE_KEY, variantData);
    }

    getSelectedValue(type) {
      if (type === 'color') {
        const colorRadio = document.querySelector('input[name*="Color"]:checked');
        if (colorRadio) return colorRadio.value;

        const colorSelect = document.querySelector('select:not([data-type="talla"])');
        return (colorSelect && colorSelect.value) || null;
      }

      if (type === 'size') {
        const sizeRadio = document.querySelector('input[name*="Talla"]:checked');
        if (sizeRadio) return sizeRadio.value;

        const sizeSelect = document.querySelector('select[data-type="talla"]');
        return (sizeSelect && sizeSelect.value) || null;
      }

      return null;
    }

    initialProcess() {
      if (document.querySelector('._rsi-quantity-offers')) {
        setTimeout(() => {
          this.processor.process();
        }, 200);

        const containers = document.querySelectorAll('._rsi-quantity-offers-offer-container');
        containers.forEach((container) => {
          new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                setTimeout(() => {
                  this.processor.process();
                }, 50);
              }
            });
          }).observe(container, {
            attributes: true,
            attributeFilter: ['class'],
          });
        });
      }
    }
  }

  new VariantHandler();

  // temporal
  function changePriceForFajas() {
    const priceElements = document.querySelectorAll('._rsi-quantity-offers-new-price, ._rsi-modal-checkout-line-value');

    priceElements.forEach((priceElement) => {
      const offerContainer = priceElement.closest('._rsi-quantity-offers-offer-container');

      const checkoutContainer = priceElement.closest('._rsi-modal-checkout-lines');

      let hasFajas = false;

      if (offerContainer) {
        const containerText = offerContainer.textContent.toUpperCase();
        hasFajas = containerText.includes('FAJA') || containerText.includes('BODY FAJA');
      } else if (checkoutContainer) {
        const modalContent = document.querySelector('._rsi-cod-form-modal, body');
        if (modalContent) {
          const modalText = modalContent.textContent.toUpperCase();
          hasFajas = modalText.includes('FAJA') || modalText.includes('BODY FAJA');
        }
      }

      if (hasFajas && priceElement.textContent.includes('200')) {
        priceElement.textContent = priceElement.textContent.replace(/200/g, '599');
      }
    });
  }

  const originalProcessMethod = VariantProcessor.prototype.process;
  VariantProcessor.prototype.process = async function () {
    await originalProcessMethod.call(this);

    setTimeout(() => {
      changePriceForFajas();
    }, 150);
  };

  const priceObserver = new MutationObserver((mutations) => {
    let shouldUpdate = false;

    mutations.forEach((mutation) => {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'class' &&
        mutation.target.classList.contains('_rsi-quantity-offers-offer-container')
      ) {
        shouldUpdate = true;
      }

      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (
            node.nodeType === 1 &&
            ((node.classList && node.classList.contains('_rsi-quantity-offers-new-price')) ||
              (node.classList && node.classList.contains('_rsi-modal-checkout-line-value')) ||
              (node.querySelector && node.querySelector('._rsi-quantity-offers-new-price, ._rsi-modal-checkout-line-value')))
          ) {
            shouldUpdate = true;
          }
        });
      }
    });

    if (shouldUpdate) {
      setTimeout(() => {
        changePriceForFajas();
      }, 100);
    }
  });

  // INP FIX: priceObserver se activa/desactiva via _rsiModalBus (modal open/close)
  // en lugar de estar activo permanentemente desde el page load.
  window._rsiPriceObserverActive = false;

  window._rsiPriceObserverStart = () => {
    if (window._rsiPriceObserverActive) return;
    priceObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true,
    });
    window._rsiPriceObserverActive = true;
    setTimeout(() => { changePriceForFajas(); }, 300);
  };

  window._rsiPriceObserverStop = () => {
    if (!window._rsiPriceObserverActive) return;
    priceObserver.disconnect();
    window._rsiPriceObserverActive = false;
  };















  
// Config Upsell 
class UpsellModalHandler {
  #selectors = Object.freeze({
    form: '_rsi-cod-form-modal-upsell',
    image: '_rsi-modal-upsell-images-slider-slide',
    parentContainer: '_rsi-cod-form-modal',
    descriptionContainer: '._rsi-modal-upsell-description',
    quantityContainer: '_rsi-modal-upsell-quantity',
    quantityDisplay: '_rsi-modal-upsell-quantity-shower',
    addButton: '_rsi-modal-add-quantity-button-upsell',
    removeButton: '_rsi-modal-remove-quantity-button-upsell',
    quantityInput: '_rsi-modal-upsell-quantity-input',
    prices: '_rsi-modal-upsell-prices',
    countdownTitle: '_rsi-modal-upsell-countdown-title',
    countdownContainer: '_rsi-modal-upsell-countdown-container',

    priceQuantityWrapper: '_rsi-price-quantity-wrapper'
  });

  #classes = Object.freeze({
    parentOverlay: '_rsi-cod-form-modal-upsell--over',
    darkOverlay: 'rsi-upsell-modal-dark-overlay',
    processedMarker: '_rsi-upsell-processed',
    quantityProcessed: '_rsi-quantity-limiter-processed',
    buttonDisabled: '_rsi-button-disabled',
    hasQuantitySelector: '_rsi-has-quantity-selector',
    reorderProcessed: '_rsi-reorder-processed',
    hasWrapper: '_rsi-has-wrapper' 
  });

  #colorMapping = new Map([
    ['[V2-VERDE]', 'rsi-upsell-v2-verde'],
    ['[V2-ROJO]', 'rsi-upsell-v2-rojo'],
    ['[V2-CAFE]', 'rsi-upsell-v2-cafe'],
    ['[V2-NARANJA]', 'rsi-upsell-v2-naranja'],
    ['[V2-CELESTE]', 'rsi-upsell-v2-celeste']
  ]);

  #observers = new Set();
  #styleElement = null;
  #isDestroyed = false;
  #processedForms = new WeakSet();
  #fullyProcessedForms = new WeakMap();
  #formsBeingProcessed = new WeakSet();
  #quantityLimiters = new WeakMap();
  #reorderedForms = new WeakSet();

  #maxQuantity = 5;
  #minQuantity = 1;

  constructor(options = {}) {
    this.#validateOptions(options);
    this.useExternalCSS = (options.useExternalCSS !== undefined && options.useExternalCSS !== null) ? options.useExternalCSS : true;
    this.debug = (options.debug !== undefined && options.debug !== null) ? options.debug : false;
    this.#maxQuantity = (options.maxQuantity !== undefined && options.maxQuantity !== null) ? options.maxQuantity : 5;
    this.#minQuantity = (options.minQuantity !== undefined && options.minQuantity !== null) ? options.minQuantity : 1;
    this.#init();
  }

  #validateOptions(options) {
    if (options && typeof options !== 'object') {
      throw new TypeError('Options must be an object');
    }
  }

  #init() {
    try {
      this.#injectBaseStyles();
      // INP FIX: el MutationObserver sobre document.body se inicia via startObserving()
      // que es llamado por _rsiModalBus cuando el modal principal se abre.
      // No lo iniciamos aquí para no tener 1 observer permanente en page load.
    } catch (error) {
      console.error('[UpsellModalHandler] Initialization failed:', error);
    }
  }

  // INP FIX: llamar cuando el modal principal se abre
  startObserving() {
    if (this.#isDestroyed) return;
    this.#setupMutationObserver();
    setTimeout(() => this.#processExistingElements(), 100);
  }

  // INP FIX: llamar cuando el modal principal se cierra
  stopObserving() {
    this.#observers.forEach(obs => obs.disconnect());
    this.#observers.clear();
  }

  #log(...args) {

    // if (this.debug) {
    //   console.log('[UpsellModalHandler]', ...args);
    // }

  }

  #injectBaseStyles() {
    if (this.useExternalCSS || this.#styleElement) return;

    this.#styleElement = document.createElement('style');
    this.#styleElement.textContent = `
      #${this.#selectors.form} {
        background-size: cover !important;
        background-position: top !important;
        background-repeat: no-repeat !important;
        transition: background-image 0.3s ease-in-out;
      }

      .${this.#classes.buttonDisabled} {
        opacity: 0.4;
        cursor: not-allowed !important;
        pointer-events: none;
      }
    `;
    document.head.appendChild(this.#styleElement);
  }

  #setupMutationObserver() {
    const observer = new MutationObserver((mutations) => {
      const processChanges = () => {
        if (this.#isDestroyed) return;
        
        try {
          this.#processMutations(mutations);
        } catch (error) {
          console.error('[UpsellModalHandler] Error processing mutations:', error);
        }
      };

      requestAnimationFrame(processChanges);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'class']
    });

    this.#observers.add(observer);
  }

  #processMutations(mutations) {
    const processedForms = new Set();

    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            this.#processNewElement(node, processedForms);
          }
        }
      } else if (mutation.type === 'attributes') {
        if (mutation.attributeName === 'src') {
          this.#handleImageSourceChange(mutation.target);
        } else if (mutation.attributeName === 'class') {
          const form = mutation.target.closest(`#${this.#selectors.form}`);
          if (form && this.#shouldProcessForm(form) && !processedForms.has(form)) {
            processedForms.add(form);
            this.#processForm(form);
          }
        }
      }
    }
  }

  #hasValidColorInDescription(form) {
    const descriptionElement = this.#findDescriptionElement(form);
    if (!descriptionElement) {
      return false;
    }

    const content = descriptionElement.textContent && descriptionElement.textContent.trim();
    if (!content) {
      return false;
    }

    const matchedColor = this.#findMatchingColor(content);
    if (!matchedColor) {
      return false;
    }
    return true;
  }

  #shouldProcessForm(form) {
    if (this.#formsBeingProcessed.has(form)) {
      return false;
    }

    if (this.#isFormFullyProcessed(form)) {
      return false;
    }

    if (!this.#hasValidColorInDescription(form)) {
      return false;
    }

    if (form.classList.contains(this.#classes.processedMarker)) {
      const expectedColorClass = this.#getExpectedColorClass(form);
      if (expectedColorClass && form.classList.contains(expectedColorClass)) {
        this.#markFormAsFullyProcessed(form, expectedColorClass);
        return false;
      }
    }

    return true;
  }

  #isFormFullyProcessed(form) {
    const processedData = this.#fullyProcessedForms.get(form);
    if (!processedData) return false;

    const hasCorrectClass = form.classList.contains(processedData.colorClass);
    const hasProcessedMarker = form.classList.contains(this.#classes.processedMarker);

    if (hasCorrectClass && hasProcessedMarker) {
      return true;
    }

    if (!hasCorrectClass || !hasProcessedMarker) {
      this.#fullyProcessedForms.delete(form);
      return false;
    }

    return false;
  }

  #getExpectedColorClass(form) {
    const descriptionElement = this.#findDescriptionElement(form);
    if (!descriptionElement) return null;

    const content = descriptionElement.textContent && descriptionElement.textContent.trim();
    if (!content) return null;

    const matchedColor = this.#findMatchingColor(content);
    return matchedColor ? this.#colorMapping.get(matchedColor) : null;
  }

  #markFormAsFullyProcessed(form, colorClass) {
    this.#fullyProcessedForms.set(form, {
      colorClass,
      timestamp: Date.now()
    });
    
    if (!form.classList.contains(this.#classes.processedMarker)) {
      form.classList.add(this.#classes.processedMarker);
    }
  }

  #processNewElement(element, processedForms) {
    const forms = element.id === this.#selectors.form 
      ? [element] 
      : (element.querySelectorAll ? element.querySelectorAll(`#${this.#selectors.form}`) : []);

    for (const form of forms) {
      if (!processedForms.has(form) && !this.#processedForms.has(form) && this.#shouldProcessForm(form)) {
        processedForms.add(form);
        this.#processedForms.add(form);
        this.#processForm(form);
      }
    }
  }

  #processExistingElements() {
    const forms = document.querySelectorAll(`#${this.#selectors.form}`);
    
    forms.forEach(form => {
      if (!this.#processedForms.has(form) && this.#shouldProcessForm(form)) {
        this.#processedForms.add(form);
        this.#processForm(form);
      }
    });
  }

  #reorderElementsIfQuantityExists(form) {
    if (this.#reorderedForms.has(form) || form.classList.contains(this.#classes.reorderProcessed)) {

      // this.#log('Formulario ya reordenado, saltando...');

      return;
    }

    const quantityContainer = form.querySelector(`.${this.#selectors.quantityContainer}`);
    
    if (!quantityContainer) {

      // this.#log('No hay selector de cantidad, no se reordena');

      return;
    }

    const pricesElement = form.querySelector(`.${this.#selectors.prices}`);
    const countdownContainerElement = form.querySelector(`.${this.#selectors.countdownContainer}`);

    if (!pricesElement || !countdownContainerElement) {

      // this.#log('No se encontraron todos los elementos necesarios para reordenar');

      return;
    }

    try {
      const pricesClone = pricesElement.cloneNode(true);
      pricesElement.remove();
      quantityContainer.parentNode.insertBefore(pricesClone, quantityContainer);
      
      this.#wrapPriceAndQuantity(form);
      
      this.#reorderedForms.add(form);
      form.classList.add(this.#classes.reorderProcessed);
      
      // this.#log('Elementos reordenados exitosamente');
      
    } catch (error) {
      console.error('[UpsellModalHandler] Error al reordenar elementos:', error);
    }
  }

  #wrapPriceAndQuantity(form) {
    if (form.classList.contains(this.#classes.hasWrapper)) {
      // this.#log('Wrapper ya aplicado, saltando...');
      return;
    }

    const pricesElement = form.querySelector(`.${this.#selectors.prices}`);
    const quantityContainer = form.querySelector(`.${this.#selectors.quantityContainer}`);

    if (!pricesElement || !quantityContainer) {
      // this.#log('No se encontraron precio o cantidad para envolver');
      return;
    }

    try {
      const wrapper = document.createElement('div');
      wrapper.className = this.#selectors.priceQuantityWrapper;

      pricesElement.parentNode.insertBefore(wrapper, pricesElement);
      wrapper.appendChild(pricesElement);
      wrapper.appendChild(quantityContainer);

      form.classList.add(this.#classes.hasWrapper);
      
      // this.#log('Wrapper aplicado: precio + cantidad envueltos en div padre');
      
    } catch (error) {
      console.error('[UpsellModalHandler] Error al aplicar wrapper:', error);
    }
  }

  #processForm(form) {
    this.#formsBeingProcessed.add(form);
    
    try {
      if (!this.#hasValidColorInDescription(form)) {
        return;
      }

      let descriptionElement = this.#findDescriptionElement(form);
      
      if (!descriptionElement) {
        return;
      }

      const content = descriptionElement.textContent && descriptionElement.textContent.trim();
      
      if (!content) {
        return;
      }

      const matchedColor = this.#findMatchingColor(content);

      if (!matchedColor) {
        return;
      }

      const cssClass = this.#colorMapping.get(matchedColor);
      
      const imageElement = form.querySelector(`.${this.#selectors.image}`);

      if (cssClass && imageElement) {
        this.#applyFormStyling(form, imageElement, cssClass);
        
        this.#setupQuantityLimiter(form);
        
        this.#reorderElementsIfQuantityExists(form);
        
        setTimeout(() => {
          this.#markFormAsFullyProcessed(form, cssClass);
          this.#verifyClassApplication(form, cssClass);
        }, 100);
        
      }
    } finally {
      setTimeout(() => {
        this.#formsBeingProcessed.delete(form);
      }, 200);
    }
  }

  #setupQuantityLimiter(form) {
    if (form.classList.contains(this.#classes.quantityProcessed)) {
      return;
    }

    const quantityContainer = form.querySelector(`.${this.#selectors.quantityContainer}`);
    
    if (!quantityContainer) {
      // this.#log('No se encontró contenedor de cantidad en el formulario');
      return;
    }

    const addButton = form.querySelector(`#${this.#selectors.addButton}`);
    const removeButton = form.querySelector(`#${this.#selectors.removeButton}`);
    const quantityDisplay = form.querySelector(`.${this.#selectors.quantityDisplay}`);
    const quantityInput = form.querySelector(`#${this.#selectors.quantityInput}`);

    if (!addButton || !removeButton || !quantityDisplay) {
      // this.#log('Faltan elementos del selector de cantidad');
      return;
    }

    form.classList.add(this.#classes.hasQuantitySelector);
    // this.#log('Clase identificadora añadida:', this.#classes.hasQuantitySelector);

    const limiterState = {
      currentQuantity: parseInt(quantityDisplay.textContent) || this.#minQuantity,
      addButton,
      removeButton,
      quantityDisplay,
      quantityInput
    };

    this.#quantityLimiters.set(form, limiterState);

    this.#attachQuantityListeners(form, limiterState);

    this.#updateQuantityState(limiterState);

    form.classList.add(this.#classes.quantityProcessed);

    // this.#log(`Limitador de cantidad configurado. Máximo: ${this.#maxQuantity}, Mínimo: ${this.#minQuantity}`);

  }

  #attachQuantityListeners(form, state) {
    const { addButton, removeButton } = state;

    const handleAdd = (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      if (state.currentQuantity < this.#maxQuantity) {
        state.currentQuantity++;
        this.#updateQuantityState(state);

        // this.#log(`Cantidad incrementada a: ${state.currentQuantity}`);

      } else {

        // this.#log(`Cantidad máxima alcanzada: ${this.#maxQuantity}`);

      }
    };

    const handleRemove = (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      if (state.currentQuantity > this.#minQuantity) {
        state.currentQuantity--;
        this.#updateQuantityState(state);

        // this.#log(`Cantidad decrementada a: ${state.currentQuantity}`);

      } else {

        // this.#log(`Cantidad mínima alcanzada: ${this.#minQuantity}`);

      }
    };

    addButton.removeEventListener('click', handleAdd);
    removeButton.removeEventListener('click', handleRemove);

    addButton.addEventListener('click', handleAdd, true);
    removeButton.addEventListener('click', handleRemove, true);

    state.handleAdd = handleAdd;
    state.handleRemove = handleRemove;

    const clickObserver = new MutationObserver(() => {
      this.#syncQuantityFromDisplay(state);
    });

    clickObserver.observe(state.quantityDisplay, {
      childList: true,
      characterData: true,
      subtree: true
    });

    this.#observers.add(clickObserver);
  }

  #syncQuantityFromDisplay(state) {
    const displayValue = parseInt(state.quantityDisplay.textContent) || this.#minQuantity;
    
    if (displayValue > this.#maxQuantity) {
      state.currentQuantity = this.#maxQuantity;
      this.#updateQuantityState(state);

      // this.#log(`Cantidad corregida al máximo: ${this.#maxQuantity}`);

    } else if (displayValue < this.#minQuantity) {
      state.currentQuantity = this.#minQuantity;
      this.#updateQuantityState(state);

      // this.#log(`Cantidad corregida al mínimo: ${this.#minQuantity}`);

    } else if (displayValue !== state.currentQuantity) {
      state.currentQuantity = displayValue;
      this.#updateQuantityState(state);
    }
  }

  #updateQuantityState(state) {
    const { currentQuantity, addButton, removeButton, quantityDisplay, quantityInput } = state;

    quantityDisplay.textContent = currentQuantity;

    if (quantityInput) {
      quantityInput.value = currentQuantity;
    }

    if (currentQuantity >= this.#maxQuantity) {
      addButton.classList.add(this.#classes.buttonDisabled);
      addButton.setAttribute('disabled', 'true');
      addButton.style.opacity = '0.4';
      addButton.style.cursor = 'not-allowed';
    } else {
      addButton.classList.remove(this.#classes.buttonDisabled);
      addButton.removeAttribute('disabled');
      addButton.style.opacity = '';
      addButton.style.cursor = '';
    }

    if (currentQuantity <= this.#minQuantity) {
      removeButton.classList.add(this.#classes.buttonDisabled);
      removeButton.setAttribute('disabled', 'true');
      removeButton.style.opacity = '0.4';
      removeButton.style.cursor = 'not-allowed';
    } else {
      removeButton.classList.remove(this.#classes.buttonDisabled);
      removeButton.removeAttribute('disabled');
      removeButton.style.opacity = '';
      removeButton.style.cursor = '';
    }
  }

#cleanupQuantityLimiters() {
  const forms = document.querySelectorAll(`#${this.#selectors.form}`);
  
  forms.forEach(form => {
    const state = this.#quantityLimiters.get(form);
    
    if (state) {
      if (state.handleAdd) {
        state.addButton.removeEventListener('click', state.handleAdd, true);
      }
      if (state.handleRemove) {
        state.removeButton.removeEventListener('click', state.handleRemove, true);
      }
    }
    
    form.classList.remove(this.#classes.quantityProcessed);
    form.classList.remove(this.#classes.hasQuantitySelector);
    form.classList.remove(this.#classes.reorderProcessed);
    form.classList.remove(this.#classes.hasWrapper);
  });
  
  this.#quantityLimiters = new WeakMap();
  this.#reorderedForms = new WeakSet();
}

  setMaxQuantity(max) {
    if (typeof max !== 'number' || max < 1) {
      throw new TypeError('Max quantity must be a positive number');
    }
    
    this.#maxQuantity = max;

    // this.#log(`Límite máximo de cantidad actualizado a: ${max}`);
    
    const forms = document.querySelectorAll(`#${this.#selectors.form}`);
    forms.forEach(form => {
      const state = this.#quantityLimiters.get(form);
      if (state) {
        if (state.currentQuantity > max) {
          state.currentQuantity = max;
        }
        this.#updateQuantityState(state);
      }
    });
  }

  getMaxQuantity() {
    return this.#maxQuantity;
  }

  #findDescriptionElement(form) {
    let element = form.querySelector('._rsi-modal-upsell-description-custom');
    if (element) {
      return element;
    }

    element = form.querySelector('._rsi-modal-upsell-description');
    if (element) {
      return element;
    }

    const allElements = form.querySelectorAll('*');
    for (const el of allElements) {
      const text = el.textContent && el.textContent.trim();
      if (text && text.includes('[V2-') && this.#findMatchingColor(text)) {
        return el;
      }
    }
    return null;
  }

  #findMatchingColor(content) {
    return Array.from(this.#colorMapping.keys()).find(color => content.includes(color));
  }
  
  #removeInlineButtonStyles(form) {
    const buttonSelectors = [
      '#_rsi-modal-submit-button-upsell',
    ];
    
    buttonSelectors.forEach(selector => {
      const buttons = form.querySelectorAll(selector);
      buttons.forEach(button => {
        button.style.removeProperty('background');
        button.style.removeProperty('color');
      });
    });
  }

  #applyFormStyling(form, imageElement, cssClass) {
    this.#removeExistingV2Classes(form);
    
    this.#addColorClass(form, cssClass);
    
    this.#setBackgroundImage(form, imageElement);

    this.#removeInlineButtonStyles(form);
    
    this.#setupImageObserver(form, imageElement, cssClass);
    
    this.#addParentContainerClass();
  }

  #setBackgroundImage(form, imageElement) {
    const applyBackground = () => {
      if (this.#isDestroyed || !imageElement.src) return;

      requestAnimationFrame(() => {
        form.style.backgroundImage = `url("${imageElement.src}")`;

        if (!this.useExternalCSS) {
          Object.assign(form.style, {
            backgroundSize: 'cover',
            backgroundPosition: 'top',
            backgroundRepeat: 'no-repeat'
          });
        }
      });
    };

    applyBackground();
  }

  #addColorClass(form, cssClass) {
    form.classList.add(cssClass);
    
    if (!form.classList.contains(cssClass)) {
      form.className = form.className + ' ' + cssClass;
    }
    
    if (!form.classList.contains(cssClass)) {
      const currentClass = form.getAttribute('class') || '';
      form.setAttribute('class', currentClass + ' ' + cssClass);
    }
  }

  #removeExistingV2Classes(form) {
    const v2Classes = Array.from(this.#colorMapping.values());
    v2Classes.forEach(className => {
      if (form.classList.contains(className)) {
        form.classList.remove(className);
      }
    });
  }

  #verifyClassApplication(form, expectedClass) {
    const hasClass = form.classList.contains(expectedClass);
    return hasClass;
  }

  #setupImageObserver(form, imageElement, cssClass) {
    const imageObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
          this.#setBackgroundImage(form, imageElement);
        }
      }
    });

    imageObserver.observe(imageElement, {
      attributes: true,
      attributeFilter: ['src']
    });

    this.#observers.add(imageObserver);
  }

  #handleImageSourceChange(imageElement) {
    if (!imageElement.classList.contains(this.#selectors.image)) return;

    const form = imageElement.closest(`#${this.#selectors.form}`);
    if (form) {
      if (!this.#hasValidColorInDescription(form)) {
        return;
      }
      
      this.#setBackgroundImage(form, imageElement);
    }
  }

  #addParentContainerClass() {
    const parentContainer = document.querySelector(`#${this.#selectors.parentContainer}`);
    if (parentContainer && !parentContainer.classList.contains(this.#classes.parentOverlay)) {
      parentContainer.classList.add(this.#classes.parentOverlay);
    }
  }

  #removeParentContainerClass() {
    const parentContainer = document.querySelector(`#${this.#selectors.parentContainer}`);
    if (parentContainer && parentContainer.classList.contains(this.#classes.parentOverlay)) {
      parentContainer.classList.remove(this.#classes.parentOverlay);
    }
  }

  addDarkOverlay(enable = true) {
    const forms = document.querySelectorAll(`#${this.#selectors.form}`);
    forms.forEach(form => {
      if (this.#hasValidColorInDescription(form)) {
        form.classList.toggle(this.#classes.darkOverlay, enable);
      }
    });
  }

  toggleExternalCSS(useExternalCSS = true) {
    if (this.useExternalCSS === useExternalCSS) return;

    this.useExternalCSS = useExternalCSS;
    this.#injectBaseStyles();
    this.#clearProcessingFlags();
    this.#processExistingElements();
  }

  #clearProcessingFlags() {
    this.#processedForms = new WeakSet();
    this.#fullyProcessedForms = new WeakMap();
    this.#formsBeingProcessed = new WeakSet();
    this.#reorderedForms = new WeakSet();
    this.#cleanupQuantityLimiters();
    
    const forms = document.querySelectorAll(`#${this.#selectors.form}`);
    forms.forEach(form => {
      form.classList.remove(this.#classes.processedMarker);
      form.classList.remove(this.#classes.quantityProcessed);
      form.classList.remove(this.#classes.hasQuantitySelector);
      form.classList.remove(this.#classes.reorderProcessed);
      form.classList.remove(this.#classes.hasWrapper);
    });
  }

  forceProcess() {
    this.#clearProcessingFlags();
    
    const forms = document.querySelectorAll(`#${this.#selectors.form}`);
    
    if (forms.length === 0) {
      this.#debugFormSearch();
      return;
    }

    forms.forEach((form) => {
      if (this.#hasValidColorInDescription(form)) {
        this.#processForm(form);
      }
    });
  }

  #debugFormSearch() {
    const allForms = document.querySelectorAll('form');
    
    allForms.forEach((form, index) => {

      // this.#log(`Formulario ${index + 1}:`, {
      //   id: form.id,
      //   classes: Array.from(form.classList),
      //   element: form
      // });

    });
  }

  addColorMapping(colorKey, cssClass) {
    if (typeof colorKey !== 'string' || typeof cssClass !== 'string') {
      throw new TypeError('Color key and CSS class must be strings');
    }
    this.#colorMapping.set(colorKey, cssClass);
  }

  getActiveColors() {
    return Array.from(this.#colorMapping.keys());
  }

  getProcessingStats() {
    const forms = document.querySelectorAll(`#${this.#selectors.form}`);
    const formsWithValidColor = forms.length ? Array.from(forms).filter(form => this.#hasValidColorInDescription(form)) : [];
    const fullyProcessedCount = formsWithValidColor.filter(form => this.#isFormFullyProcessed(form)).length;
    const quantityLimitersCount = Array.from(forms).filter(form => 
      form.classList.contains(this.#classes.quantityProcessed)
    ).length;
    const formsWithQuantitySelector = Array.from(forms).filter(form =>
      form.classList.contains(this.#classes.hasQuantitySelector)
    ).length;
    const reorderedFormsCount = Array.from(forms).filter(form =>
      form.classList.contains(this.#classes.reorderProcessed)
    ).length;
    const formsWithWrapper = Array.from(forms).filter(form =>
      form.classList.contains(this.#classes.hasWrapper)
    ).length;
    
    return {
      totalForms: forms.length,
      formsWithValidColor: formsWithValidColor.length,
      fullyProcessed: fullyProcessedCount,
      beingProcessed: this.#formsBeingProcessed ? Array.from(forms).filter(form => this.#formsBeingProcessed.has(form)).length : 0,
      quantityLimitersActive: quantityLimitersCount,
      formsWithQuantitySelector: formsWithQuantitySelector,
      reorderedForms: reorderedFormsCount,
      formsWithWrapper: formsWithWrapper,
      maxQuantity: this.#maxQuantity,
      minQuantity: this.#minQuantity
    };
  }

  diagnose() {
    const stats = this.getProcessingStats();

    const forms = document.querySelectorAll(`#${this.#selectors.form}`);
    forms.forEach((form, index) => {
      const hasValidColor = this.#hasValidColorInDescription(form);
      const hasQuantityLimiter = form.classList.contains(this.#classes.quantityProcessed);
      const hasQuantitySelector = form.classList.contains(this.#classes.hasQuantitySelector);
      const isReordered = form.classList.contains(this.#classes.reorderProcessed);
      const hasWrapper = form.classList.contains(this.#classes.hasWrapper);
      const limiterState = this.#quantityLimiters.get(form);
      const wrapper = form.querySelector(`.${this.#selectors.priceQuantityWrapper}`);
    });
  }

  destroy() {
    if (this.#isDestroyed) return;
    this.#isDestroyed = true;

    this.#cleanupQuantityLimiters();

    this.#observers.forEach(observer => {
      observer.disconnect();
    });
    this.#observers.clear();

    this.#styleElement && this.#styleElement.remove();
    this.#styleElement = null;

    this.#removeParentContainerClass();

    const forms = document.querySelectorAll(`#${this.#selectors.form}`);
    forms.forEach(form => {
      this.#removeExistingV2Classes(form);
      form.classList.remove(
        this.#classes.darkOverlay, 
        this.#classes.processedMarker,
        this.#classes.quantityProcessed,
        this.#classes.hasQuantitySelector,
        this.#classes.reorderProcessed,
        this.#classes.hasWrapper
      );
      form.style.removeProperty('background-image');
      if (!this.useExternalCSS) {
        form.style.removeProperty('background-size');
        form.style.removeProperty('background-position');
        form.style.removeProperty('background-repeat');
      }
    });
    this.#clearProcessingFlags();
  }
}

const initializeUpsellHandler = (options = {}) => {
  try {
    const handler = new UpsellModalHandler({
      useExternalCSS: true,
      debug: false,
      maxQuantity: 5,
      minQuantity: 1,
      ...options
    });

    const cleanup = () => {
      handler.destroy();
      window.removeEventListener('unload', cleanup);
      window.removeEventListener('beforeunload', cleanup);
    };

    window.addEventListener('unload', cleanup);
    window.addEventListener('beforeunload', cleanup);

    window.UpsellModalHandler = UpsellModalHandler;
    window.upsellHandler = handler;

    window.debugUpsell = () => handler.forceProcess();
    window.diagnoseUpsell = () => handler.diagnose();
    window.setQuantityLimit = (max) => handler.setMaxQuantity(max);

    return handler;
  } catch (error) {
    console.error('[UpsellModalHandler] Error al inicializar:', error);
    return null;
  }
};

const startHandler = () => {
  const handler = initializeUpsellHandler();
  // INP FIX: forceProcess ya no se llama en page load porque el observer
  // del UpsellModalHandler sólo arranca cuando el modal se abre via _rsiModalBus.
  // El handler existe para que el bus pueda llamar handler.startObserving()
  // cuando el modal abra, y handler.stopObserving() cuando cierre.
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startHandler);
} else {
  startHandler();
}

window.addEventListener('load', () => {
  if (!window.upsellHandler) {
    startHandler();
  }
});







// Auto-deactivate gift upsells when first quantity offer is selected
class UpsellDeactivator {
  #sel = Object.freeze({
    offer: '._rsi-quantity-offers-offer-container',
    selected: '_rsi-quantity-offers-selected',
    upsell: '._rsi-tick-ups-container',
    hidden: '[data-tick-ups-hidden-input="true"]',
    checkbox: '[data-tick-ups-visible-checkbox="true"]'
  });

  #cfg = { target: '0', ids: [], off: '-1' };
  #obs = null;
  #dead = false;
  #last = null;

  constructor(opt = {}) {
    this.debug = (opt.debug !== undefined && opt.debug !== null) ? opt.debug : true;
    this.#cfg.target = (opt.targetOfferPosition !== undefined && opt.targetOfferPosition !== null) ? opt.targetOfferPosition : '0';
    this.#init();
  }

  #init() {
    try {
      // Check if feature is enabled via metafield
      if (!this.#isEnabled()) {
        // this.#log('Feature disabled by metafield');
        return;
      }

      this.#loadIds();
      // INP FIX: el observer sobre document.body se inicia via startWatching()
      // que es llamado por _rsiModalBus cuando el modal principal se abre.

      // this.#log('Ready (observer deferred to modal open)');

    } catch (e) {
      console.error('[UpsellDeactivator] Init error:', e);
    }
  }

  // INP FIX: llamar cuando el modal principal se abre
  startWatching() {
    if (this.#dead) return;
    if (!this.#isEnabled()) return;
    this.#loadIds();
    this.#watch();
    this.#check();
  }

  // INP FIX: llamar cuando el modal principal se cierra
  stopWatching() {
    if (this.#obs) {
      this.#obs.disconnect();
      this.#obs = null;
    }
  }

  // Check if feature is enabled via Shopify metafield
  #isEnabled() {
    return !!(window._RSI_FIRST_OFFER_CONFIG && window._RSI_FIRST_OFFER_CONFIG.enabled === true);
  }

  #log(...a) {

    // if (this.debug) console.log('[UpsellDeactivator]', ...a);

  }

  // Load gift upsell IDs from global script
  #loadIds() {
    if (!window._RSI_COD_FORM_TICK_UPS) {
      // this.#log('_RSI_COD_FORM_TICK_UPS not found');
      return;
    }

    this.#cfg.ids = window._RSI_COD_FORM_TICK_UPS
      .filter(u => u.price === 0 && u.ticked)
      .map(u => u.id.toString());

    // this.#log('Gift upsells:', this.#cfg.ids);
  }

  // Watch for offer selection changes
  #watch() {
    if (this.#obs) return; // INP FIX: guard contra duplicados
    this.#obs = new MutationObserver(m => {
      if (this.#dead) return;
      
      for (const { type, attributeName, target } of m) {
        if (type === 'attributes' && 
            attributeName === 'class' && 
            target.classList.contains('_rsi-quantity-offers-offer-container')) {
          this.#handle(target);
        }
      }
    });

    this.#obs.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });
  }

  #check() {
    const el = document.querySelector(
      `${this.#sel.offer}[data-offer-pos="${this.#cfg.target}"]`
    );

    if (el && el.classList.contains(this.#sel.selected)) {
      // this.#log('Target already selected');
      this.#off();
    }
  }

  // Handle offer selection change
  #handle(el) {
    const pos = el.getAttribute('data-offer-pos');
    const selected = el.classList.contains(this.#sel.selected);

    if (this.#last === el && selected) return;

    // this.#log(`Offer ${pos} - ${selected ? 'selected' : 'unselected'}`);

    if (pos === this.#cfg.target && selected) {
      this.#last = el;
      this.#off();
    } else if (selected) {
      this.#last = el;
      this.#on();
    }
  }

  // Deactivate gift upsells
  #off() {
    let n = 0;

    this.#cfg.ids.forEach(id => {
      const c = document.querySelector(`${this.#sel.upsell}[data-tick-ups-id="${id}"]`);
      if (!c) return;

      const h = c.querySelector(`${this.#sel.hidden}[data-tick-ups-id="${id}"]`);
      const v = c.querySelector(`${this.#sel.checkbox}[data-tick-ups-id="${id}"]`);

      if (h) h.value = this.#cfg.off;
      
      if (v && v.checked) {
        v.checked = false;
        v.dispatchEvent(new Event('change', { bubbles: true }));
      }

      n++;
    });

    // this.#log(`${n} upsells deactivated`);
  }

  // Reactivate gift upsells
  #on() {
    let n = 0;

    this.#cfg.ids.forEach(id => {
      const c = document.querySelector(`${this.#sel.upsell}[data-tick-ups-id="${id}"]`);
      if (!c) return;

      const h = c.querySelector(`${this.#sel.hidden}[data-tick-ups-id="${id}"]`);
      const v = c.querySelector(`${this.#sel.checkbox}[data-tick-ups-id="${id}"]`);
      const orig = window._RSI_COD_FORM_TICK_UPS && window._RSI_COD_FORM_TICK_UPS.find(function(u) { return u.id.toString() === id; });

      if (!orig) return;

      const val = `vid_${orig.connV}_0`;

      if (h && h.value === this.#cfg.off) h.value = val;
      
      if (v && !v.checked && orig.ticked) {
        v.checked = true;
        v.dispatchEvent(new Event('change', { bubbles: true }));
      }

      n++;
    });

    // this.#log(`${n} upsells reactivated`);
  }

  forceCheck() {
    this.#check();
  }

  getStats() {
    const all = document.querySelectorAll(this.#sel.offer);
    const sel = document.querySelector(`${this.#sel.offer}.${this.#sel.selected}`);
    const pos = (sel && sel.getAttribute('data-offer-pos')) || 'none';

    return {
      totalOffers: all.length,
      selectedPosition: pos,
      targetPosition: this.#cfg.target,
      upsellsMonitored: this.#cfg.ids.length,
      isTargetSelected: pos === this.#cfg.target
    };
  }

  diagnose() {

    // console.log(' === UPSELL DEACTIVATOR DIAGNOSTIC ===');
    // console.log(' Stats:', this.getStats());
    
    // console.log('Monitored upsells:');

    this.#cfg.ids.forEach(id => {
      const c = document.querySelector(`${this.#sel.upsell}[data-tick-ups-id="${id}"]`);
      const h = c && c.querySelector(this.#sel.hidden);
      const v = c && c.querySelector(this.#sel.checkbox);

      // console.log(`  Upsell ${id}:`, {
      //   exists: !!c,
      //   hiddenValue: h && h.value,
      //   checkboxChecked: v && v.checked
      // });

    });

    // console.log('Quantity offers:');

    document.querySelectorAll(this.#sel.offer).forEach(o => {
      const p = o.getAttribute('data-offer-pos');
      const s = o.classList.contains(this.#sel.selected);

      // console.log(`  Offer ${p}: ${s ? 'Selected' : 'Not selected'}`);

    });
  }

  destroy() {
    if (this.#dead) return;
    this.#dead = true;
    this.#obs && this.#obs.disconnect();
    this.#obs = null;
    this.#last = null;
    // this.#log('Destroyed');
  }
}

// Auto-init
const init = (opt = {}) => {
  try {
    const d = new UpsellDeactivator({ debug: false, targetOfferPosition: '0', ...opt });

    window.upsellDeactivator = d;
    window.checkUpsells = () => d.diagnose();
    window.forceCheckUpsells = () => d.forceCheck();

    const cleanup = () => {
      d.destroy();
      window.removeEventListener('unload', cleanup);
      window.removeEventListener('beforeunload', cleanup);
    };

    window.addEventListener('unload', cleanup);
    window.addEventListener('beforeunload', cleanup);

    // console.log('UpsellDeactivator loaded. Commands: checkUpsells(), forceCheckUpsells()');

    return d;
  } catch (e) {
    console.error('[UpsellDeactivator] Init error:', e);
    return null;
  }
};

const start = () => setTimeout(() => init(), 500);

document.readyState === 'loading' 
  ? document.addEventListener('DOMContentLoaded', start) 
  : start();

window.addEventListener('load', () => !window.upsellDeactivator && start());




// Auto-fill email field - Integrado con Releasit
const emailAutoFill = (() => {
  const config = {
    emailSelector: '#_rsi-field-email',
    defaultEmail: 'hishopsoporte@gmail.com',
    maxRetries: 20,
    retryDelay: 500
  };

  let retries = 0;

  const setEmail = () => {
    const emailInput = document.querySelector(config.emailSelector);
    
    if (emailInput) {
      emailInput.value = config.defaultEmail;
      emailInput.dispatchEvent(new Event('input', { bubbles: true }));
      emailInput.dispatchEvent(new Event('change', { bubbles: true }));

      // console.log('Email establecido:', config.defaultEmail);

      return true;
    }
    return false;
  };

  const attempt = () => {
    if (setEmail()) {
      return;
    }

    retries++;
    if (retries < config.maxRetries) {
      setTimeout(attempt, config.retryDelay);
    } else {
      console.warn('No se pudo encontrar el campo de email después de varios intentos');
    }
  };

  return {
    init: () => {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', attempt);
      } else {
        setTimeout(attempt, 100);
      }
    }
  };
})();

emailAutoFill.init();